import {
  Directive,
  HostBinding,
  HostListener,
  Output,
  EventEmitter,
  OnInit,
} from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Directive({
  selector: '[fileDragDrop]',
})
export class DragndropFileDirective implements OnInit {
  @HostBinding('class.error') error!: boolean;
  @HostBinding('class.fileover') fileOver!: boolean;

  @Output('fileUploadedEvent') fileUploadedEvent = new EventEmitter();

  @HostListener('dragover', ['$event']) ondragover(event: any) {
    this._stabilize(event);
    this.fileOver = true;
    console.log(event);
  }

  @HostListener('dragleave', ['$event']) ondragleave(event: Event) {
    this._stabilize(event);
    this.fileOver = false;
  }

  @HostListener('drop', ['$event']) ondrop(event: any) {
    this._stabilize(event);

    this.fileOver = false;
    const files = event.dataTransfer.files;

    if (files.length > 0) {
      const file = event.dataTransfer.files[0];
      this.fileUploadedEvent.emit(file);
    }
  }

  constructor(private snakeBar: MatSnackBar) {}
  ngOnInit() {}

  private _stabilize(event: Event) {
    event.preventDefault();
    event.stopPropagation();
  }

  private say(message: string) {
    this.snakeBar.open(message, '', { duration: 2000 });
  }
}
